"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const LineStyle_1 = require("./LineStyle");
const XYPosition_1 = require("./XYPosition");
exports.ArcSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('arc'),
    lineWidth: zod_1.z.number(),
    lineStyle: LineStyle_1.LineStyleSchema.optional(),
    center: XYPosition_1.XYPositionSchema,
    radius: zod_1.z.number(),
    startAngle: zod_1.z.number(),
    endAngle: zod_1.z.number(),
});
//# sourceMappingURL=Arc.js.map